/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ArchetypeHandlingResultR = t.interface({});

// optional attributes
const ArchetypeHandlingResultO = t.partial({
  generated_archetypes: t.Integer,

  subsystem_url: t.string
});

export const ArchetypeHandlingResult = t.intersection(
  [ArchetypeHandlingResultR, ArchetypeHandlingResultO],
  "ArchetypeHandlingResult"
);

export type ArchetypeHandlingResult = t.TypeOf<typeof ArchetypeHandlingResult>;
